export default "__VITE_ASSET__6MRBB7ZM__"